export const SEARCHBOX_ANCHOR_ID = 'searchBoxAnchorId';
export const SEARCHBOX_ID = 'searchBoxId';
